<template>
  <div class="app-container" v-bind:class="platform">
    <main id="main">
      <div class="view-container">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
    name: 'app',
    mounted () {
    },
    computed: mapGetters({
        version: 'cordova/version',
        deviceReady: 'cordova/deviceReady',
        resolution: 'device/resolution',
        logged: 'auth/checkLogin',
        platform: 'cordova/platform',
        settings: 'company/config'
    }),
    methods: {
        checkVersion (currentVersion, lastVersion) {
            console.log(currentVersion, lastVersion, lastVersion > currentVersion);
            if (currentVersion > 0 && lastVersion > 0) {
                if (lastVersion > currentVersion) {
                    let options = {
                        isForgettable: false,
                        isModal: true,
                        callback: () => {}
                    };
                    this.$alertForgettable('app_new_version', this.translate('appNewVersion'), options);
                }
            }
        }
    },
    watch: {
        deviceReady: () => {
            console.log('Device ready from components');
        },
        version: function (newVersionValue) {
            console.log('new version value');
            this.checkVersion(newVersionValue, this.settings ? this.settings.ultima_version : 0);
        },
        settings: function (newSettingsValue) {
            console.log('new settings value this.version', this.version, this.settings.ultima_version);
            this.checkVersion(this.version, this.settings ? this.settings.ultima_version : 0);
        }
    },
    data () {
        return {

        };
    }
};
</script>



// WEBPACK FOOTER //
// src/App.vue